export default __webpack_public_path__ + "static/media/2_0160.f62192d9.webp";